<template>
  <!-- <div class='tags-wrap'>
        <div :class="{tags:true, active:status==='all'?true:false}" @click="$router.replace('/user/order?status=all')">全部订单</div>
        <div :class="{tags:true, active:status==='0'?true:false}" @click="$router.replace('/user/order?status=0')">待付款</div>
        <div :class="{tags:true, active:status==='1'?true:false}" @click="$router.replace('/user/order?status=1')">待收货</div>
    </div> -->

  <div class="goods-screen-main">
    <div class="goods-screen-option">
      <ul>
        <li
          :class="{ active: status === 'all' ? true : false }"
          @click="$router.replace('/user/order?status=all')"
        >
          <span>全部</span>
        </li>
        <li
          :class="{ active: status === '0' ? true : false }"
          @click="$router.replace('/user/order?status=0')"
        >
          <span>待付款</span>
        </li>
        <li
          :class="{ active: status === '1' ? true : false }"
          @click="$router.replace('/user/order?status=1')"
        >
          <span>已付款</span>
        </li>
        <li
          :class="{ active: status === '2' ? true : false }"
          @click="$router.replace('/user/order?status=2')"
        >
          <span>已取消</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "order-tags",
  props: {
    status: {
      type: String,
      default: "all",
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-wrap {
  width: 100%;
  height: 0.8rem;
  background-color: #ffffff;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 1.02rem;
  border-bottom: #dcdcdc solid 1px;
  display: flex;
  display: -webkit-flex;
}
.tags-wrap .tags {
  width: 25%;
  height: 100%;
  text-align: center;
  font-size: 0.28rem;
  line-height: 0.8rem;
}
.tags-wrap .tags.active {
  border-bottom: #e42321 1px solid;
}
.goods-screen-main {
  padding: 0 0.55rem;
  .goods-screen-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ul {
      display: flex;
      align-items: center;
      li {
        margin-right: 0.64rem;
        font-size: 0.26rem;
        color: #939393;
        position: relative;
        line-height: 1.2;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.08rem;
          background: url("../../assets/images/home/goods/screen-on.png")
            no-repeat center bottom;
          background-size: 100% 100%;
          opacity: 0;
        }
        &.active {
          color: #201e1e;
          &::after {
            opacity: 1;
          }
        }
      }
    }

    .tool-right {
      display: flex;
      align-items: center;
      .view-wrap {
        font-size: 0;
        .ui-icon {
          display: inline-block;
          width: 0.36rem;
          height: 0.36rem;
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
        }
        .ui-icon-one {
          background-image: url("../../assets/images/home/goods/icon-one.png");
        }
        .ui-icon-two {
          background-image: url("../../assets/images/home/goods/icon-two.png");
        }
      }
    }
  }
}
</style>